import React, { useEffect, useState } from 'react';
import { TextField, InputAdornment, Button } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from "@mui/icons-material/Clear";
import styled from 'styled-components';
import LabelText from '../LabelText';


interface SearchInputProps {
  handleSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClear: () => void;
  placeholder?: string;
  fontSize?: string;
  type?: string;
  clearInput?: boolean;
  autoFocus?: boolean;
  setIsFocus?: React.Dispatch<React.SetStateAction<boolean>>;
}

const StyledSearchInput = styled(TextField) <{ fontSize?: string }>`
  caret-color: #00D1A8;
  .MuiOutlinedInput-root {
    height: 48px;
    // margin-bottom:8px;
    color: var(--Warm-Grey-warm-grey-500, #A2A4A1);

    /* Aeonik/Display/Large */
    font-family: 'Aeonik';
    font-size: ${({ fontSize }) => fontSize || '16px'};
    font-style: normal;
    font-weight: 700;
    line-height: 66px; /* 117.857% */
    // border-radius: 4px;
    // border: 1px solid var(--Warm-Grey-warm-grey-400, #C2C2C2);
    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.playerDataBorder} /* Border color on hover */
    }
    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.playerDataBorder} /* Border color when focused */
    }
    &.Mui-error .MuiOutlinedInput-notchedOutline {
      border-color:${({ theme }) => theme.playerDataBorder} /* Border color when there is an error */
    }
    & .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.playerDataBorder} /* Initial border color */
    }
    & .MuiInputBase-input-MuiOutlinedInput-input{
      
    }
    // & .MuiOutlinedInput-notchedOutline{
    //   border: none;
    // }
    
  }
  .MuiInputBase-input {
    color: ${({ theme }) => theme.playerColor};
    font-family: 'Aeonik';
    font-size: ${({ fontSize }) => fontSize || '16px'};
    font-style: normal;
    font-weight: 700;
    line-height: 66px; 
    @media(max-width: 1366px){
      font-size: 20px;
      line-height: 30px; 
    }
  }
  // .MuiInputAdornment-root {
  //   color: black; /* Change icon color to red */
  // }
  .SearchIcon{
    color: ${({ theme }) => theme.matchLabel};
    filter: ${({ theme }) => (theme.mode === "light" ? "none" : "grayscale(100%) brightness(0) invert(1)")};

  }
  .ClearIcon{
    color: ${({ theme }) => theme.NumberColor}
  }

  .clear-button {
    border: none;
    // background-color: ${({ theme }) => theme.playerCardBackground};
    background: none;
  }
`;



const SearchInput: React.FC<SearchInputProps> = ({ handleSearch, handleClear,
  placeholder, fontSize, type, clearInput,autoFocus=true,setIsFocus }) => {
  const [searchInput, setSearchInput] = useState<string>("");
  const [isFocused, setIsFocused] = useState<boolean>(false);


  const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
    handleSearch(event);
  };

  const handleClearClick = () => {
    setSearchInput("");
    handleClear();
  };

  useEffect(() => {
    if (clearInput) {
      setSearchInput("");
      handleClear();
    }
  }, [clearInput]);

  const handleFocus = () => {
    setIsFocused(true);
    setIsFocus && setIsFocus(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
    setIsFocus && setIsFocus(false);
  };


  return (
    <StyledSearchInput
      onFocus={handleFocus}
      onBlur={handleBlur}
      value={searchInput}
      // placeholder={placeholder ? placeholder : 'Search'}
      placeholder={!isFocused ? (placeholder || 'Search') : ''}
      fullWidth
      autoFocus={autoFocus}
      autoComplete="off"
      fontSize={fontSize && fontSize}
      InputProps={{
        endAdornment: (
          (type && type === "SearchPlayer" && searchInput.length >= 3) ?
            // <Button variant="text" onClick={handleClearClick}>Clear</Button>
            <button className='clear-button' onClick={handleClearClick}>
              <LabelText className='clear-labeltext'>Clear</LabelText>
            </button> :
            <InputAdornment position="end">
              {searchInput && type !== "SearchPlayer" && (
                <ClearIcon
                  // style={{ cursor: "pointer !important" }}
                  onClick={handleClearClick}
                  className='ClearIcon'
                />
              )}
              {type && (<SearchIcon style={{width: "32px", height: "32px"}} className='SearchIcon' />)}
            </InputAdornment>

        )
      }}
      onChange={handleSearchInputChange}
    />
  );
};

export default SearchInput;
